import { useState } from 'react';
import { useInterval } from 'react-use';

import { Box, Stack, Typography } from '@mui/material';

import StyledOtpInput from 'src/component-library/OtpInput';

const DefaultCountdown = 30;

interface OtpCodeInputProps {
    otp: string;
    onOtpChange: (otp: string) => void;
    phoneNumber: string;
    onResend: () => void;
    hasError?: boolean;
    disabled?: boolean;
}

export function OtpCodeInput(props: OtpCodeInputProps) {
    const { otp, onOtpChange, phoneNumber, onResend, hasError = false } = props;

    const [seconds, setSeconds] = useState(DefaultCountdown);

    useInterval(
        () => {
            setSeconds((s) => s - 1);
        },
        seconds > 0 ? 1_000 : null
    );

    const handleResend = () => {
        setSeconds(DefaultCountdown);
        onResend();
    };

    return (
        <Stack sx={{ gap: 2 }}>
            <Typography variant="body2">
                Enter the 6-digit code sent to (•••) ••• {phoneNumber.slice(8, 12)}
            </Typography>
            <StyledOtpInput value={otp} onChange={onOtpChange} hasErrored={hasError} />
            {hasError && (
                <Typography variant="body2" sx={{ color: 'error.main' }}>
                    Invalid code. Please try again.
                </Typography>
            )}
            <Box>
                <Typography variant="body1">Didn&apos;t receive a code?&nbsp;</Typography>
                {seconds === 0 ? (
                    <Typography
                        variant="body1"
                        onClick={handleResend}
                        sx={{ fontWeight: 'bold', color: 'primary.main', cursor: 'pointer' }}
                    >
                        Resend the code
                    </Typography>
                ) : (
                    <Typography variant="body1">
                        Resend in <strong>00:{seconds < 10 ? `0${seconds}` : seconds}</strong>
                    </Typography>
                )}
            </Box>
        </Stack>
    );
}
